import {createAction} from 'redux-actions'

export const reset = createAction('BATCHES/RUNNERS/RESET')
export const startPoll = createAction('BATCHES/RUNNERS/START_POLL')
export const stopPoll = createAction('BATCHES/RUNNERS/STOP_POLL')
export const receiveByBatchId = createAction(
    'BATCHES/RUNNERS/RECEIVE_BY_BATCH_ID',
    (ids, count) => ({ids, count}),
)
